<div class="skeleton-main">
    <div class="squire skeleton" *ngFor="let _ of [].constructor(6)"></div>
</div>
<div class="skeleton-bottom">
    <div class="bottom skeleton"></div>
</div>
